import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type ConfigState = {
  config: { colors: any } | null | undefined
}

const initialState: ConfigState = {
  config: {
    colors: []
  }
}

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig(state, action: PayloadAction<any | null>) {
      state.config = action.payload
    }
  }
})

export const { setConfig } = configSlice.actions

export default configSlice.reducer
